import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import {
    PaymentOutboxItemModel,
    PaymentOutboxStatsModel,
    PaymentOutboxRetryResult,
} from "@/core/models/payment-outbox.model";

interface _PaymentOutboxGetParams {
    waterFactoryId?: string;
    status?: number;
    channel?: string;
    fromDate?: string;
    toDate?: string;
    search?: string;
}

@injectable()
export class PaymentOutboxRepo extends TableRepo<PaymentOutboxItemModel> {
    protected getPagePath = "items";

    constructor() {
        super("/api/PaymentOutbox");
    }

    async getData(
        index: number,
        params: _PaymentOutboxGetParams,
        pageSize = 50
    ): Promise<ApiPage<PaymentOutboxItemModel> | null> {
        return await super.getData(index, params, pageSize);
    }

    async getStats(): Promise<PaymentOutboxStatsModel | null> {
        try {
            const response = await this.apiRepo.get<PaymentOutboxStatsModel>(
                `${this.basepath}/stats`
            );
            if (response?.code === "00") {
                return response.result;
            }
        } catch (err) {
            console.log(err);
        }
        return null;
    }

    async retryDead(ids: string[]): Promise<PaymentOutboxRetryResult | null> {
        try {
            const response = await this.apiRepo.post<PaymentOutboxRetryResult>(
                `${this.basepath}/retry`,
                { ids }
            );
            if (response?.code === "00") {
                this.changes.next(Date.now());
                return response.result;
            }
        } catch (err) {
            console.log(err);
        }
        return null;
    }
}
